const DEFAULT_PHONE_NUMBER_REGEX = {
    type: 'regex',
    regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
    value: ' ($1 $2 $3) — ($4 $5 $6) — ($7 $8, $9 $10) '
};
// Fallback for Female 11labs
const Katie = {
    // Katie - Cartesia - https://play.cartesia.ai/voices/f786b574-daa5-4673-aa0c-cbe3e8534c02
    model: 'sonic-2',
    voiceId: 'f786b574-daa5-4673-aa0c-cbe3e8534c02',
    provider: 'cartesia',
    chunkPlan: {
        formatPlan: {
            replacements: [
                {
                    type: 'regex',
                    regex: '\\*',
                    value: ''
                }
            ],
            enabled: true,
            formattersEnabled: [
                'markdown',
                'quote',
                'newline',
                'colon',
                'date',
                'time',
                'email',
                'phoneNumber',
                'percentage',
                'dollarAmount',
                'number',
                'distance',
                'acronym'
            ]
        },
        minCharacters: 60
    },
    experimentalControls: {
        speed: 'normal'
    },
    fillerInjectionEnabled: false,
    inputPunctuationBoundaries: ['?', '!', '.']
};
// Fallback for Male 11labs
const Ronald = {
    // Ronald - Cartesia - https://play.cartesia.ai/voices/5ee9feff-1265-424a-9d7f-8e4d431a12c7
    model: 'sonic-2',
    voiceId: '5ee9feff-1265-424a-9d7f-8e4d431a12c7',
    provider: 'cartesia',
    chunkPlan: {
        formatPlan: {
            replacements: [
                {
                    type: 'regex',
                    regex: '\\*',
                    value: ''
                }
            ],
            enabled: true,
            formattersEnabled: [
                'markdown',
                'quote',
                'newline',
                'colon',
                'date',
                'time',
                'email',
                'phoneNumber',
                'percentage',
                'dollarAmount',
                'number',
                'distance',
                'acronym'
            ]
        },
        minCharacters: 60
    },
    experimentalControls: {
        speed: 'slow'
    },
    fillerInjectionEnabled: false,
    inputPunctuationBoundaries: ['?', '!', '.']
};
// Fallback for Male Cartesia
const Scott = {
    model: 'eleven_turbo_v2',
    voiceId: '9T9vSqRrPPxIs5wpyZfK',
    provider: '11labs',
    chunkPlan: {
        formatPlan: {
            replacements: [
                {
                    type: 'regex',
                    regex: '\\*',
                    value: ''
                },
                {
                    type: 'regex',
                    regex: '$',
                    value: ' —'
                },
                {
                    type: 'regex',
                    regex: '\\? —',
                    value: '?'
                },
                {
                    type: 'regex',
                    regex: '\\. —',
                    value: '...'
                },
                {
                    type: 'regex',
                    regex: '<break5 />',
                    value: '<break time="5s" />'
                },
                {
                    type: 'regex',
                    regex: '<break10 />',
                    value: '<break time="10s" />'
                },
                DEFAULT_PHONE_NUMBER_REGEX
            ],
            enabled: true,
            formattersEnabled: [
                'markdown',
                'quote',
                'dash',
                'newline',
                'colon',
                'date',
                'time',
                'email',
                'phoneNumber',
                'percentage',
                'dollarAmount',
                'number',
                'distance',
                'acronym'
            ]
        },
        minCharacters: 60
    },
    speed: 1,
    stability: 0.9,
    similarityBoost: 0.6,
    useSpeakerBoost: false,
    enableSsmlParsing: true,
    fillerInjectionEnabled: false,
    inputPunctuationBoundaries: ['?', '!', '.'],
    fallbackPlan: {
        voices: [Ronald]
    }
};
// Fallback for Femal Cartesia
const Vanessa = {
    model: 'eleven_turbo_v2',
    speed: 1.1,
    voiceId: 'y63GIN9vPuGrYuHPYT92',
    provider: '11labs',
    chunkPlan: {
        formatPlan: {
            enabled: true,
            replacements: [
                {
                    type: 'regex',
                    regex: '\\*',
                    value: ''
                },
                {
                    type: 'regex',
                    regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                    value: ' $1 $2 $3, $4 $5 $6, $7 $8, $9 $10 '
                }
            ],
            formattersEnabled: [
                'markdown',
                'quote',
                'dash',
                'newline',
                'colon',
                'date',
                'time',
                'email',
                'phoneNumber',
                'percentage',
                'dollarAmount',
                'number',
                'distance',
                'acronym'
            ]
        },
        minCharacters: 60
    },
    stability: 0.95,
    similarityBoost: 0.7,
    useSpeakerBoost: false,
    enableSsmlParsing: true,
    fillerInjectionEnabled: false,
    inputPunctuationBoundaries: ['?', '!', '.'],
    fallbackPlan: {
        // Cartesia fallback
        voices: [Katie]
    }
};
// VAPI's ElevenLabs models; the pinned SDK's enum lacks eleven_v3 and eleven_v4_turbo
export const ELEVENLABS_MODELS = [
    'eleven_multilingual_v2',
    'eleven_turbo_v2',
    'eleven_turbo_v2_5',
    'eleven_flash_v2',
    'eleven_flash_v2_5',
    'eleven_monolingual_v1',
    'eleven_v3',
    'eleven_v4_turbo'
];
export const AGENT_VOICES = {
    Vanessa: {
        voice: Vanessa,
        flag: '🇺🇸'
    },
    Adam: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.06,
            voiceId: 'jb0HMmAoC5pul05cWeDO',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Nora: {
        voice: {
            model: 'eleven_turbo_v2_5',
            speed: 1.08,
            voiceId: 'p56V2oggoVME1OOR0jVn',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: ' $1 $2 $3, $4 $5 $6, $7 $8, $9 $10 '
                        }
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.5,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Ivan: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.06,
            voiceId: 'j8ug8hId0zlBITTMvRNg',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Penny: {
        voice: {
            model: 'eleven_multilingual_v2',
            voiceId: 'MnUw1cSnpiLoLhpd3Hqp',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: '. $1  $2  $3 ... $4  $5  $6 ... $7. $8. $9. $10... '
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Lucas: {
        voice: {
            model: 'eleven_turbo_v2',
            voiceId: 'UgBBYS2sOqTuMpoF3BR0',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Eric: {
        voice: {
            model: 'eleven_turbo_v2',
            voiceId: 'SF9uvIlY93SJRMdV5jeP',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: '. ($1, $2, $3) — ($4, $5, $6) — ($7. $8. $9. $10)... '
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Nico: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 0.93,
            voiceId: 'RKtetyndWXI10Vd2VTCx',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: ' $1 $2 $3, $4 $5 $6, $7 $8, $9 $10 ...'
                        }
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.75,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Alfie: {
        voice: {
            model: 'eleven_multilingual_v2',
            speed: 1.0,
            voiceId: 'Fahco4VZzobUeiPqni1S',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇬🇧'
    },
    Carmen: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.0,
            voiceId: 'uJ86qhFmlBK1XXN7NhEt',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.75,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Timmy: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.0,
            voiceId: 'buqvU9fKO96TtaLEbWga',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.75,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Valerie: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.0,
            voiceId: 'kSDv9EbJ41pJUICMEOOu',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: ' $1 $2 $3, $4 $5 $6, $7 $8, $9 $10 ...'
                        }
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.75,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Miguel: {
        voice: {
            model: 'eleven_turbo_v2_5',
            speed: 1.06,
            voiceId: 'dlGxemPxFMTY7iXagmOj',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                voices: [Ronald]
            }
        },
        flag: '🇪🇸'
    },
    Sofia: {
        voice: {
            model: 'eleven_turbo_v2_5',
            speed: 1.06,
            voiceId: 'spPXlKT5a4JMfbhPRAzA',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇪🇸'
    },
    Samuel: {
        voice: {
            model: 'eleven_turbo_v2_5',
            speed: 1.06,
            voiceId: 'nmvA11Y688M5reLqDsVm',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇪🇸'
    },
    Isabel: {
        voice: {
            model: 'eleven_turbo_v2_5',
            speed: 1.06,
            voiceId: 'rixsIpPlTphvsJd2mI03',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇪🇸'
    },
    Marc: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.06,
            voiceId: 'eE1wxhUj3eTk2goTCsix',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.75,
            similarityBoost: 0.7,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Tim: {
        voice: {
            model: 'eleven_turbo_v2',
            voiceId: 'rYW2LlWtM70M5vc3HBtm',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        {
                            type: 'regex',
                            regex: '[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*(\\d)[^A-Za-z0-9_]*',
                            value: '. ($1, $2, $3) — ($4, $5, $6) — ($7. $8. $9. $10)... '
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Scott: {
        voice: Scott,
        flag: '🇺🇸'
    },
    Jessica: {
        voice: {
            model: 'eleven_turbo_v2',
            voiceId: '56AoDkrOh6qfVPDXZ7Pt',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Emily: {
        voice: {
            model: 'eleven_turbo_v2',
            voiceId: 'tnSpp4vdxKPjI9w0GnoV',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            speed: 1,
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Katie]
            }
        },
        flag: '🇺🇸'
    },
    Brian: {
        voice: {
            model: 'eleven_turbo_v2',
            speed: 1.1,
            voiceId: 'pqHfZKP75CvOlQylNhV4',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        {
                            type: 'regex',
                            regex: '$',
                            value: ' —'
                        },
                        {
                            type: 'regex',
                            regex: '\\? —',
                            value: '?'
                        },
                        {
                            type: 'regex',
                            regex: '\\. —',
                            value: '...'
                        },
                        {
                            type: 'regex',
                            regex: '<break5 />',
                            value: '<break time="5s" />'
                        },
                        {
                            type: 'regex',
                            regex: '<break10 />',
                            value: '<break time="10s" />'
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.9,
            similarityBoost: 0.6,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    },
    Alistair: {
        voice: {
            model: 'sonic-2',
            voiceId: '95856005-0332-41b0-935f-352e296aa0df',
            provider: 'cartesia',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            experimentalControls: {
                speed: 'slow'
            },
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // 11labs fallback
                voices: [Scott]
            }
        },
        flag: '🇬🇧'
    },
    Rachel: {
        voice: {
            model: 'sonic-2',
            voiceId: '248be419-c632-4f23-adf1-5324ed7dbf1d',
            provider: 'cartesia',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            experimentalControls: {
                speed: 'normal'
            },
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // 11labs fallback
                voices: [Vanessa]
            }
        },
        flag: '🇺🇸'
    },
    Tucker: {
        voice: {
            model: 'sonic-2',
            voiceId: '40104aff-a015-4da1-9912-af950fbec99e',
            provider: 'cartesia',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            experimentalControls: {
                speed: 'slow'
            },
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // 11labs fallback
                voices: [Scott]
            }
        },
        flag: '🇺🇸'
    },
    Lisa: {
        voice: {
            model: 'sonic-2',
            voiceId: '829ccd10-f8b3-43cd-b8a0-4aeaa81f3b30',
            provider: 'cartesia',
            chunkPlan: {
                formatPlan: {
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        }
                    ],
                    enabled: true,
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            experimentalControls: {
                speed: 'normal'
            },
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // 11labs fallback
                voices: [Vanessa]
            }
        },
        flag: '🇺🇸'
    },
    Brandon: {
        voice: {
            model: 'eleven_multilingual_v2',
            speed: 1.06,
            voiceId: 'sZ1zCDBJ1Lq4N8kH7jL5',
            provider: '11labs',
            chunkPlan: {
                formatPlan: {
                    enabled: true,
                    replacements: [
                        {
                            type: 'regex',
                            regex: '\\*',
                            value: ''
                        },
                        DEFAULT_PHONE_NUMBER_REGEX
                    ],
                    formattersEnabled: [
                        'markdown',
                        'quote',
                        'dash',
                        'newline',
                        'colon',
                        'date',
                        'time',
                        'email',
                        'phoneNumber',
                        'percentage',
                        'dollarAmount',
                        'number',
                        'distance',
                        'acronym'
                    ]
                },
                minCharacters: 60
            },
            stability: 0.8,
            similarityBoost: 0.9,
            useSpeakerBoost: false,
            enableSsmlParsing: true,
            fillerInjectionEnabled: false,
            inputPunctuationBoundaries: ['?', '!', '.'],
            fallbackPlan: {
                // Cartesia fallback
                voices: [Ronald]
            }
        },
        flag: '🇺🇸'
    }
};
//# sourceMappingURL=agent-voices.js.map